import Vue from 'vue';

export default {
    addPaymentToBill (state, payment) {
        Vue.set(payment, 'selected', false);
        const bill = state.bills[payment.billId];
        if (bill) {
            if (bill.payments.find(p => p.id === payment.id))
                return;
            bill.payments.push(payment);
        }
        else
            Vue.set(state.bills, payment.billId, { id: payment.billId, ...payment.bill, payments: [ payment ] });
    },
    removePaymentInBill (state, payment) {
        state.bills[payment.billId].payments = state.bills[payment.billId].payments.filter(p => p.id !== payment.id);
    },
    setPending (state, snapshot) {
        const bills = [];
        snapshot.forEach(b => {
            bills.push(b.data());
            state.lastSnapshot = Object.freeze(b);
        });
        state.pendingBills = [ ...state.pendingBills, ...bills ];
    },
    addPendingInvoice (state, invoice) {
        state.pendingInvoices.push(invoice);
    },
    removePendingInvoice (state, invoice) {
        state.pendingInvoices = state.pendingInvoices.filter(i => i.id !== invoice.id);
    },
    setFetchFlag (state, value) {
        state.moreToFetch = value;
    },
    setLoading (state, value) {
        state.busy = value;
    },
    setFetched (state, billId) {
        state.sent[billId] = true;
    },
    addListener(state, listener) {
        state.listeners = { ...state.listener, ...listener };
    },
    clearBills (state) {
        state.bills = {};
        state.sent = {};
    },
    clearSent (state) {
        state.sentInvoices = [];
    },
    clearDisposed (state) {
        state.disposedInvoices = [];
    },
    clearBackup (state) {
        state.pendingInvoices = [];
    },
    clearIgnored (state) {
        state.ignoredPayments = [];
    },
    addToIgnored (state, payment) {
        Vue.set(payment, 'selected', false);
        const bill = state.ignoredPayments[payment.billId];
        if (bill) {
            if (bill.payments.find(p => p.id === payment.id))
                return;
            bill.payments.push(payment);
        }
        else
            Vue.set(state.ignoredPayments, payment.billId, { id: payment.billId, ...payment.bill, payments: [ payment ] });
    },
    removeIgnored (state, value) {
        state.ignoredPayments = state.ignoredPayments.filter(p => p !== value.id);
    },
    addToSent (state, invoice) {
        state.sentInvoices.push(invoice);
    },
    removeSent (state, invoice) {
        state.sentInvoices = state.sentInvoices.filter(i => i.id !== invoice.id);
    },
    addToDisposed (state, invoice) {
        state.disposedInvoices.push(invoice);
    },
    removeDisposed (state, invoice) {
        console.log('Removed     listener', invoice.id);
        state.disposedInvoices = state.disposedInvoices.filter(i => i.id !== invoice.id);
    }
}